/* Copyright (c) 2018 Scaper */

import { FunctionsType } from "./api";

export function executeCallable<Request = never, Response = never>(
    functions: FunctionsType,
    functionName: string,
    request: Request,
): Promise<Response> {
    const httpsCallable = functions().httpsCallable(functionName);
    return httpsCallable(request).then(({ data }) => data);
}
